// The boards and grades there are — read from the API, never from a constant.
//
// They used to be `BOARDS` / `GRADES` arrays compiled into the bundle, which is
// what made adding a board a code change. Now a platform operator adds one in
// the curriculum console and every picker here shows it on its next fetch.
import { useQuery } from '@tanstack/react-query';
import type { CurriculumLevelsDTO } from '@cwy/config/contracts';
import { apiGet } from '@/lib/api';

export const CURRICULUM_LEVELS_KEY = ['curriculum-levels'] as const;

export function useCurriculumLevels(enabled = true) {
  return useQuery({
    queryKey: CURRICULUM_LEVELS_KEY,
    queryFn: () => apiGet<CurriculumLevelsDTO>('/curriculum/levels'),
    enabled,
    // Changes when an operator adds a board — rare, and a refetch on focus covers it.
    staleTime: 5 * 60_000,
  });
}

/** The label a person reads for a code, falling back to the code itself. */
export function levelLabel(
  levels: CurriculumLevelsDTO | undefined,
  kind: 'boards' | 'grades',
  code: string,
): string {
  return levels?.[kind].find((l) => l.code === code)?.label ?? code;
}
